import { render } from "./XmlPositionDataView.vue?vue&type=template&id=236e9d5f&scoped=true&ts=true"
import script from "./XmlPositionDataView.vue?vue&type=script&lang=ts"
export * from "./XmlPositionDataView.vue?vue&type=script&lang=ts"

import "./XmlPositionDataView.vue?vue&type=style&index=0&id=236e9d5f&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236e9d5f"]])

export default __exports__